import { SxProp } from 'src/types/mui';

export const paperStyles: SxProp = {
  borderRadius: 2,
  border: '0.5px solid',
  borderColor: '#C5C5C5',
  p: 4,
};
